import { Pipe, PipeTransform } from "@angular/core";
import { SyncAction } from "../../shared/types/sync-action";

export const getActionType = (action: SyncAction) => {
	const typeFromPath = action.path.split("/")[2];

	if (typeFromPath === "data") {
		return "medical-parameters";
	}

	return action.path.split("/")[2] || "unknown";
};

@Pipe({
	name: "actionTypeName",
	standalone: false,
})
export class ActionTypeNamePipe implements PipeTransform {
	transform(action: SyncAction): string {
		return getActionType(action);
	}
}
